

export class featureToggleCollectionVisibility {

    private visibilitySteps: { opacity: number, className: string }[];
    private currentOpacity: number;

    constructor( visibilitySteps: { opacity: number, className: string }[], currentOpacity: number ) {
        this.visibilitySteps = visibilitySteps;
        this.currentOpacity = currentOpacity;
    }

    isVisible(): boolean {
        return this.currentOpacity > 0;
    }

    getOpacity(): number {
        return this.currentOpacity;
    }

    getVisibilityClassName(): string {
        for (let i=0; i<this.visibilitySteps.length; i++) {
            if (this.currentOpacity === this.visibilitySteps[i].opacity) {
                return this.visibilitySteps[i].className;
            }
        }
        return '';
    }

    setNextVisibilityStep(): number {
        let nextOpacity = 0;
        for (let i=0; i<this.visibilitySteps.length; i++) {
            if (this.currentOpacity === this.visibilitySteps[i].opacity) {
                if (i < this.visibilitySteps.length - 1) {
                    nextOpacity = this.visibilitySteps[i+1].opacity;
                } else {
                    nextOpacity = this.visibilitySteps[0].opacity;
                }
                break;
            }
        }
        this.currentOpacity = nextOpacity;
        return nextOpacity;
    }

}